// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Bankrupt } from './bankrupt';
import { Contact } from './contact';
import { Counterparty } from './counterparty';
import { Creditor } from './creditor';
import { Document } from './document';
import { DocumentRecipientAction } from './document-recipient-action';
import { Employee } from './employee';
import { Entry } from './entry';
import { Shareholder } from './shareholder';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class DocumentRecipient extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  documentRecipientId!: number;
  bankruptId?: number;
  contactId?: number;
  counterpartyId?: number;
  createdBy!: string;
  createdDate!: Date;
  creditorId?: number;
  documentId!: number;
  employeeId?: number;
  entryId?: number;
  shareholderId?: number;
  ts!: string;
  bankrupt!: Bankrupt;
  contact!: Contact;
  counterparty!: Counterparty;
  creditor!: Creditor;
  document!: Document;
  documentRecipientActions!: DocumentRecipientAction[];
  employee!: Employee;
  entry!: Entry;
  shareholder!: Shareholder;
}

